module.exports = __webpack_public_path__ + "static/media/icon_celebration.34cbbde8.svg";